import {
  Box,
  IconButton,
  Typography,
  Badge,
  Button,
  Link,
} from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { enToFaDigit } from "../../utility/utils";
const BottomNav = ({ customItems }) => {
  const { search } = useLocation();
  let query = new URLSearchParams(search);
  const config = useSelector((state) => state.config);
  const cart = useSelector((state) => state.cart);
  const cartList = cart.list;
  var count = 0;

  cartList?.map((item) => {
    count = count + item?.number;
  });

  const items = customItems || config.NavBoxItems || [];
  var showFromApp = query.get("from") === "app";
  let from = localStorage.getItem("from");
  if (from && from === "app") {
    showFromApp = true;
  } else if (query.get("from") === "app") {
    localStorage.setItem("from", "app");
  }
  return (
    <Box
      sx={{
        display: {
          xs: showFromApp ? "none" : "flex",
          md: "none",
        },
        width: "100%",
        height: "70px",
        bgcolor: "primary.main",
        position: "fixed",
        bottom: "0",
        left: "0",
        justifyContent: "space-between",
        px: 1.5,
        zIndex: 100,
        overflow: "hidden",
      }}
    >
      {items.map((item) => {
        return (
          <Link
            component={RouterLink}
            to={item.path}
            key={item.path}
            sx={{
              height: "100%",
              width: `${100 / items.length}%`,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {item?.path === "/cart" && cartList.length > 0 ? (
              <Badge
                badgeContent={enToFaDigit(count + "")}
                color="secondary"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                overlap="circular"
              >
                <IconButton
                  size="large"
                  sx={{
                    color: "#fff",
                    mb: 1,
                  }}
                >
                  <item.icon fontSize="large" />
                </IconButton>
              </Badge>
            ) : (
              <IconButton
                size="large"
                sx={{
                  color: "#fff",
                  mb: 1,
                }}
              >
                <item.icon fontSize="large" />
              </IconButton>
            )}
            <Typography
              sx={{
                width: "120px",
                fontSize: "12px",
                position: "absolute",
                bottom: "5px",
                left: "50%",
                transform: "translateX(-50%)",
                color: "#fff",
                transition: "all 0.3s ease-in-out",
              }}
              align="center"
            >
              {item.name}
            </Typography>
          </Link>
        );
      })}
    </Box>
  );
};

export default BottomNav;
